import { useQuery } from "@tanstack/react-query";
import moment from "moment";

import { getDataSubmissionDates } from "services";

import { getEnvironment, getIsSubmissionPeriodOpen, useGetFarms } from "utils";

import { GET_DATA_SUBMISSION_DATES } from "consts";

import { DataSubmissionDatesResponse } from "models";

const isAdmin = getEnvironment().admin;

export const useGetDataSubmissionDates = () => {
  const { currentFarm } = useGetFarms();
  const startYear = currentFarm?.carbonProgram?.startYear;

  return useQuery({
    queryKey: [GET_DATA_SUBMISSION_DATES, startYear],
    queryFn: async () => {
      const resp = await getDataSubmissionDates();

      if (startYear && startYear > moment(resp.submissionStartDate).year()) {
        for (const [key, date] of Object.entries(resp)) {
          resp[key as keyof DataSubmissionDatesResponse] = moment(date).year(startYear).toISOString();
        }
      }

      const isSubmissionPeriodOpen = getIsSubmissionPeriodOpen(resp.submissionStartDate, resp.submissionEndDate);

      return { ...resp, isSubmissionPeriodOpen };
    },
    enabled: !isAdmin,
  });
};
